import React, { useEffect, useState } from "react";
import { Route, Link, Switch, useParams } from "react-router-dom";
import About from "../components/About";
import Contact from "../components/Contact";
import Portfolio from "../components/Portfolio";
import Service from "../components/Service";

import "../scss/subPage.scss";

function SubPage() {
  const { type } = useParams();
  const [title, setTitle] = useState("");
  useEffect(() => {
    switch (type) {
      case "about":
        setTitle("회사소개");
        break;
      case "service":
        setTitle("서비스안내");
        break;
      case "portfolio":
        setTitle("포트폴리오");
        break;
      case "contact":
        setTitle("문의하기");
        break;
  
      default:
        break;
    }
  })
  return (
    <main>
      <div className="subBanner">
        <img src={`/image/subPage/${type}Banner.jpg`} alt="" />
        <h2>{ title }</h2>
      </div>
      <Switch>
        <Route path="/about">
          <About></About>
        </Route>
        <Route path="/service">
          <Service></Service>
        </Route>
        <Route path="/portfolio/:pageName">
          <Portfolio></Portfolio>
        </Route>
        <Route path="/contact">
          <Contact></Contact>
        </Route>
      </Switch>
    </main>
  );
}

export default SubPage;
